/**
 * Natal (D1) placement facts shown beside a divisional chart: the sign and
 * degree of a sidereal longitude and its nakshatra/pada. Formatting only; the
 * longitude and nakshatra come from the engine response.
 */

import { formatSignDegree, nakshatraName } from "@/app/prashna-kundali/PrashnaChartLabels";
import { RASHIS } from "@/lib/rashi-presentation";

type Language = "en" | "hi";

/** Degree and arc-minute within the sign, floored (29°59.9′ shows as 29°59′). */
export function degreeInSign(longitude: number): string {
  return formatSignDegree(((longitude % 30) + 30) % 30);
}

/** "Dhanu 16°47′" (Vedic id, as the result's sign columns show it) or "धनु 16°47′". */
export function natalPosition(longitude: number, language: Language): string {
  const normalized = ((longitude % 360) + 360) % 360;
  const rashi = RASHIS.find((entry) => entry.number === Math.floor(normalized / 30) + 1);
  if (!rashi) return degreeInSign(normalized);
  const name =
    language === "hi" ? rashi.name_hi : `${rashi.id.charAt(0).toUpperCase()}${rashi.id.slice(1)}`;
  return `${name} ${degreeInSign(normalized)}`;
}

/** "Purva Ashadha, pada 2" or "पूर्वाषाढ़ा, चरण 2"; an em dash when the engine sent none. */
export function nakshatraPada(
  id: string | null | undefined,
  pada: number | null | undefined,
  language: Language
): string {
  if (!id) return "—";
  const name = nakshatraName(id, language === "hi");
  if (!pada) return name;
  return `${name}, ${language === "hi" ? "चरण" : "pada"} ${pada}`;
}
